import axios from '@/lib/AxApi';

export default
{
    getDentalSolutions(params, cb)
    {
        axios.get('/rest/DentalSolutions/selectRow',
            {
                params: params
            })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    selectDentalSolutionUsers(params, cb)
    {
        axios.get('/rest/DentalSolutions/selectDentalSolutionUsers',
            {
                params: params
            })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    getReport(params, cb)
    {
        axios.get('/rest/DentalSolutions/getReport',
            {
                params: params
            })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    getMonthlyReport(params, cb)
    {
        axios.get('/rest/DentalSolutions/getMonthlyReport',
            {
                params: params
            })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    getClientReport(params, cb)
    {
        axios.get('/rest/DentalSolutions/getClientReport',
            {
                params: params
            })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    saveDentalSolution(params, cb)
    {
        if (typeof params.id != 'undefined' && params.id != '')
        {
            axios.post('/rest/DentalSolutions/updateRow', params)
                .then(response =>
                {
                    cb(response.data);
                })
                .catch(e =>
                {
                    //TODO
                })
        }
        else
        {
            axios.post('/rest/DentalSolutions/insertRow', params)
                .then(response =>
                {
                    cb(response.data);
                })
                .catch(e =>
                {
                    //TODO
                })
        }
    },
    deleteDentalSolution(params, cb)
    {
        axios.post('/rest/DentalSolutions/deleteRow', params)
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    uploadStl(params, cb)
    {
        axios.post('/rest/DentalSolutions/uploadStl', params)
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    deleteStl(params, cb)
    {
        axios.post('/rest/DentalSolutions/deleteStl', params)
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    changeFilePlatform(params, cb)
    {
        axios.post('/rest/DentalSolutions/changeFilePlatform', params)
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    saveAll(params, cb)
    {
        axios.get('/rest/DentalSolutions/saveAll', {
            params
        })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    getDentalSolutionPossibleUsers(params, cb)
    {
        axios.get('/rest/DentalSolutions/getDentalSolutionPossibleUsers',
            {
                params: params
            })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    getDentalSolutionOrdererCompanies(params, cb)
    {
        axios.get('/rest/DentalSolutions/getDentalSolutionOrdererCompanies',
            {
                params: params
            })
            .then(response =>
            {
                cb(response.data);
            })
            .catch(e =>
            {
                //TODO
            })
    },
    async deleteOpened()
    {
        await axios.get('/rest/DentalSolutions/deleteOpened')
    },
}


// WEBPACK FOOTER //
// ./src/api/dentalsolutions.js